import React from "react";
import Report from "../../../components/cases/report";
const AdvisorReport = () => {
  return (
    <div>
      <Report />
    </div>
  );
};

export default AdvisorReport;
